import { computed, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BaseStore } from '@client-libs';
import { map } from 'rxjs';

export interface IMenu {
  name: string;
  href?: string;
  children?: IMenu[];
  icon?: string;
  description?: string;

  /**
   * @description 최고 관리 권한을 가진 메뉴입니다.
   */
  super?: boolean;

  /**
   * @description 오른쪽에 화살표(>)를 표시합니다.
   */
  showArrow?: boolean;
}

type State = {
  menus: IMenu[];
  path: string;
};

@Injectable({ providedIn: 'root' })
export class LayoutStore extends BaseStore<State> {
  menus$ = this.state$.pipe(map(state => state.menus));
  path$ = this.state$.pipe(map(state => state.path));

  menus = toSignal(this.menus$);
  path = toSignal(this.path$);

  currentMenu = computed<IMenu | undefined>(() =>
    this.menus()?.find(menu => {
      if (menu.children) {
        return menu.children.some(child =>
          this.path()?.startsWith(child.href ?? '')
        );
      }

      return this.path()?.startsWith(menu.href ?? '');
    })
  );

  currentChildMenu = computed<IMenu | undefined>(() => {
    const currentMenu = this.currentMenu();

    if (currentMenu?.children) {
      return currentMenu.children.find(child =>
        this.path()?.startsWith(child.href ?? '')
      );
    }

    return undefined;
  });

  constructor() {
    super({
      menus: [],
      path: '',
    });
  }

  setPath(path: string) {
    this.updateState({ path });
  }

  setMenus(menus: IMenu[]) {
    this.updateState({ menus });
  }
}
